module.exports = __webpack_public_path__ + "static/media/Group_btn.7217a401.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/Group_btn.png
// module id = 462
// module chunks = 0